<template>
  <div class="welcome" :style="{ zoom: scaleva }">
    <!-- <h1 class="title font_b">ALUDYNE汽车零部件（南通）工厂DPLUS数字化生产平台</h1> -->
    <h1 class="title font_b">
      佶缔纳士IIOT智能化运维管理平台
    </h1>
    <h2 class="subTitle font_b">Nash Intelligent IIoT Equipment Management System</h2>
    <!-- <div v-if="user.user_type==='customer'"  class="system-item item1"></div> -->

    <div style="height: 30%;display: flex;align-items: center;justify-content: center;">
      <!-- v-show="item.visible&&$store.state.permission.code&&$store.state.permission.code.includes(item.permCode)" -->
      <div
          v-for="(item, index) in systemList"
          :class="['system-item', `item${item.index}`,`${systemList.length>4?('items'+index):''}`]"
          :key="index"
      >
        <div :class="['system-pic-link']" @click="redirect(item)">
          <div class="system_name">
            <div class="zh-name">{{ item.zh_name }}</div>
            <div class="zh-system">{{ item.zh_sys }}</div>
            <div class="en-name font_b">{{ item.en_name }}</div>
            <div class="en-system font_b">{{ item.en_sys }}</div>
          </div>
          <img class="system-pic" :src="item.pic"  alt="#"/>
          <i class="system-pic-line" v-for="item in 8" :key="item"></i>
        </div>
        <!--<div :class="['link_line', `line${index}`]"></div>-->
      </div>
    </div>

    <canvas id="canvasBg" class="welcome-bg"></canvas>
  </div>
</template>

<script>
import { particleWelcome } from "@/utils/canvas";
import {onMounted, ref} from 'vue'
import { menuItems } from "@/config/menu";
import _ from "lodash";
export default {
  setup () {
    const scaleva = ref()
    const bodyScale = () => {
      const devicewidth = document.documentElement.clientWidth// 获取当前分辨率下的可视区域宽度
      // 分母——设计稿的尺寸
      scaleva.value = devicewidth / 1920
    }
    onMounted(() => {
      bodyScale()
      window.onresize = () => {
        return (() => {
          bodyScale()
        })()
      }
    })

    return {
      scaleva,
    }
  },
  name: "welcome",
  methods: {
    redirect(item) {
      this.$router.push(item.path.name);
    },
    /* 符合权限跳转 */
    findPath(menu,perm){
      let path = null
      for (let i = 0; i < menu.length; i++) {  
        const condition = menu[i].permCode;  
          
        // 遍历对象数组查找匹配的元素  
        for (let j = 0; j < perm.length; j++) {  
            const obj = perm[j];               
            // 检查条件是否匹配  
            if (obj === condition) {  
                // 找到匹配元素，赋值给a并停止查找 
                path = menu[i];  
                break; // 跳出内部循环  
            }  
        }            
        // 如果已经找到匹配元素，则跳出外部循环  
        if (path !== null) {  
            break; // 跳出外部循环  
        }  
      }   
      return path;
    }
  },
  mounted() {

    particleWelcome("#canvasBg", "#0ec8e6");
  },
  computed: {
    menuPath(){
      let reslut = [],
          filter = ["dashboard.overview","dashboard.home","dashboard.device","dashboard.order","dashboard.bo","dashboard.cloud"]; //排除跳转云图的menu
      const _menuItems = _.cloneDeep(menuItems);
      _menuItems.map(item=>{
        reslut.push(...item.subItems)
      })
      //排除掉云图 dashboard.cloud(防止跳转时再次返回云图内相关跳转)
      return reslut.filter(a=>!filter.includes(a.permCode));
    },
    user(){
      return JSON.parse(localStorage.getItem("user"))
    },
    systemList() { //3和5
      let toHomePath = '/user-profile'
      let list = JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type==='customer'?[
        {
          pic: require("../assets/welcome/主页.svg"),
          path: { name: "/iot/atlas-analysis" },
          key: "Home",
          zh_name: "",
          zh_sys: "AI分析",
          en_name: "",
          en_sys: "AI Analysis",
          permCode: "order.get",
          index:2,
          visible:true
        },
        {
          pic: require("../assets/welcome/设备.svg"),
          path: { name: "/fullIndex?path=4" },
          key: "AI",
          zh_name: "",
          zh_sys: "设备",
          en_name: "",
          en_sys: "Equipment",
          permCode: "order.get",
          index:3,
          visible:true
        },
        {
          pic: require("../assets/welcome/工单.svg"),
          path: { name: "/work-order" },
          key: "AI",
          zh_name: "",
          zh_sys: "工单",
          en_name: "",
          en_sys: "Work Orders",
          permCode: "order.get",
          index:4,
          visible:true
        },
      ]:[
        {
          pic: require("../assets/welcome/总览.svg"),
          path: { name: "/fullIndex?path=0" },
          key: "MES",
          zh_name: "",
          zh_sys: "总览",
          en_name: "",
          en_sys: "Overview",
          permCode: "dashboard.overview",
          index:0,
          visible:true
        },
        {
          pic: require("../assets/welcome/主页.svg"),
          path: { name: "/user-profile" },
          key: "AI",
          zh_name: "",
          zh_sys: "主页",
          en_name: "",
          en_sys: "Home",
          permCode: "dashboard.home",
          index:1,
          visible:true
        },
        {
          pic: require("../assets/welcome/设备.svg"),
          path: { name: "/fullIndex?path=1" },
          key: "AI",
          zh_name: "",
          zh_sys: "设备",
          en_name: "",
          en_sys: "Equipment",
          permCode: "dashboard.device",
          index:2,
          visible:true
        },
        {
          pic: require("../assets/welcome/工单.svg"),
          path: { name: "/fullIndex?path=2" },
          key: "AI",
          zh_name: "",
          zh_sys: "工单",
          en_name: "",
          en_sys: "Work Orders",
          permCode: "dashboard.order",
          index:3,
          visible:true
        },
        {
          pic: require("../assets/welcome/商机.svg"),
          path: { name: "/fullIndex?path=3" },
          key: "Home",
          zh_name: "",
          zh_sys: "商机",
          en_name: "",
          en_sys: "Opportunies",
          permCode: "dashboard.bo",
          index:4,
          visible:true
        },
      ];
      /* 主页跳转有权限页面 */
      let index = list.findIndex(a=>a.permCode ==="dashboard.home"),
          permission = this.$store.state.permission.code;

      if(index>-1) {
        //查看用户是否有主页排除'个人信息'页面权限(约定),其他页面,则跳转.无则跳转'个人信息'页面/user-profile
        if(permission.length>0&&this.findPath(this.menuPath,permission)){
          list[index].path= { name: this.findPath(this.menuPath,permission).link } //个人信息页面
          toHomePath = this.findPath(this.menuPath,permission).link
        }
      }
      localStorage.setItem("toHomePath",toHomePath) //总览，设备等dashboard页面home按钮跳转使用

      let result = list.filter(item=>item.visible&&permission.includes(item.permCode))
      return result
    }
  }

};
</script>

<style lang="scss" scoped>
$pic-width: 340px;
$animationTime: 0.5s;
$color: #18c0e5;

.welcome {
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  background-image: url("../assets/welcome/welcome.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .welcome-bg {
    position: absolute;
    left: 52%;
    top: 52%;
    width: 60%;
    height: 35%;
    z-index: 100;
    transform: translateX(-50%);
  }

  .canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
  }

  .title,
  .subTitle {
    font-size: 47px;
    line-height: 47px;
    font-weight: bold;
    margin-top: 3%;
    text-align: center;
    color: $color;
  }
  .subTitle {
    font-size: 40px;
    line-height: 40px;
    margin-top: 20px;
  }

  .system-item {
    margin: 0 2%;
    display: inline-block;
    // position: relative;
    width: $pic-width;
    box-sizing: border-box;
    z-index: 11; 
    // &:nth-of-type(2) {
    //   left: 4% !important;
    // }
    // &:nth-of-type(3) {
    //   left: 5% !important;
    // }
    // &:nth-of-type(4) {
    //   left: 6% !important;
    // }
    // &:nth-of-type(5) {
    //   left: 8% !important;
    // }
    // &:nth-of-type(6) {
    //   left: 33% !important;
    // }
    .link_line {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 8px;
      height: 180px;
      background-image: url("../assets/welcome/line.png");
      background-repeat: no-repeat;
      background-size: cover;
    }

    .system-pic-link {
      position: relative;
      display: block;
      margin: 0 auto;
      cursor: pointer;
      background: #0b1f3c;
      padding: 15px;

      .system-pic {
        display: block;
      }
      .system_name {
        position: absolute;
        z-index: 999;
        width: 135px;
        // padding: 10px 0;
        box-sizing: border-box;
        color: #17b8dc;
        font-size: 12px;
        text-align: center;
        top: 135px;
        // left: 18px;
        text-transform: uppercase;

        .zh-system {
          margin-bottom: 8px;
        }
      }
      &:hover {
        .system-pic-line {
          @each $i in 1, 5 {
            &:nth-of-type(#{$i}) {
              animation: moveFull2Hor $animationTime linear;
            }

            @keyframes moveFull2Hor {
              0% {
                width: 20px;
              }
              49% {
                width: 100%;
              }
              50% {
                width: 20px;
              }
            }
          }

          @each $i in 3, 7 {
            &:nth-of-type(#{$i}) {
              animation: moveFull2Ver $animationTime linear;
            }

            @keyframes moveFull2Ver {
              0% {
                height: 20px;
              }
              49% {
                height: 100%;
              }
              50% {
                height: 20px;
              }
            }
          }

          @each $i in 2, 6 {
            &:nth-of-type(#{$i}) {
              animation: full2ZeroHor $animationTime linear;
            }

            @keyframes full2ZeroHor {
              49% {
                width: 20px;
              }
              50% {
                width: 100%;
              }
              100% {
                width: 20px;
              }
            }
          }

          @each $i in 4, 8 {
            &:nth-of-type(#{$i}) {
              animation: full2ZeroVer $animationTime linear;
            }

            @keyframes full2ZeroVer {
              49% {
                height: 20px;
              }
              50% {
                height: 100%;
              }
              100% {
                height: 20px;
              }
            }
          }
        }
      }

      .system-pic-line {
        position: absolute;
        background-color: $color;

        @each $i in 1, 2, 5, 6 {
          &:nth-of-type(#{$i}) {
            width: 20px;
            height: 2px;
          }
        }

        @each $i in 3, 4, 7, 8 {
          &:nth-of-type(#{$i}) {
            width: 2px;
            height: 20px;
          }
        }

        @each $i in 1, 2, 3, 8 {
          &:nth-of-type(#{$i}) {
            top: 0;
          }
        }

        @each $i in 4, 5, 6, 7 {
          &:nth-of-type(#{$i}) {
            bottom: 0;
          }
        }

        @each $i in 1, 6, 7, 8 {
          &:nth-of-type(#{$i}) {
            left: 0;
          }
        }

        @each $i in 2, 3, 4, 5 {
          &:nth-of-type(#{$i}) {
            right: 0;
          }
        }
      }
    }

    @each $i, $bottom in (0: 25, 1: 60, 2: 50, 3: 30, 4: 25) {
      &:nth-of-type(#{$i + 1}) {
        left: 3%;
        opacity: 0;
        animation: move#{$i} 0.3s 0.3s * $i;
        animation-fill-mode: forwards;
      }

      @keyframes move#{0} {
        0% {
          top: 0;
          opacity: 0.5;
        }
        100% {
          top: 14%;
          opacity: 1;
        }
      }
      @keyframes move#{1} {
        0% {
          top: 0;
          opacity: 0.5;
        }
        100% {
          top: 5%;
          opacity: 1;
        }
      }
      @keyframes move#{2} {
        0% {
          top: 0;
          opacity: 0.5;
        }
        100% {
          top: 5%;
          opacity: 1;
        }
      }
      @keyframes move#{3} {
        0% {
          top: 0;
          opacity: 0.5;
        }
        100% {
          top: 5%;
          opacity: 1;
        }
      }
      @keyframes move#{4} {
        0% {
          top: 0;
          opacity: 0.5;
        }
        100% {
          top: 14%;
          opacity: 1;
        }
      }
    }
  }
  .items0{
      align-self:flex-end;
    }
  .items4{
    align-self:flex-end;
  }
}
</style>
